import { render, staticRenderFns } from "./FormSujetoExcluido.vue?vue&type=template&id=6680323c&scoped=true&"
import script from "./FormSujetoExcluido.vue?vue&type=script&lang=js&"
export * from "./FormSujetoExcluido.vue?vue&type=script&lang=js&"
import style0 from "./FormSujetoExcluido.vue?vue&type=style&index=0&id=6680323c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6680323c",
  null
  
)

export default component.exports